import { TitledContainer } from 'components';

import { useGetRequest } from 'hooks';

import { CollectorNumberInput, DynamicForm, EnhancedMatching } from './components';

export const Configuration = () => {
  const { data } = useGetRequest<Record<string, string>>({ url: '/configuration' });

  return (
    <TitledContainer title='Configuration'>
      <DynamicForm data={data} />

      <EnhancedMatching data={data} />

      <CollectorNumberInput />
    </TitledContainer>
  );
};
